import { useLang } from "../../i18n/LanguageContext";

export const LanguageToggle = ({ onNavigate }) => {
    const { lang, setLang } = useLang();

    const choose = (next) => {
        setLang(next);
        if (onNavigate) onNavigate();
    };

    return (
        <div
            role="group"
            aria-label="Idioma / Language"
            data-testid="language-toggle"
            className="inline-flex items-center rounded-full border border-linea bg-white/90 p-0.5 text-xs font-semibold text-acero"
        >
            <button
                type="button"
                onClick={() => choose("es")}
                aria-pressed={lang === "es"}
                data-testid="lang-es-btn"
                className={`rounded-full px-3 py-1 transition-colors ${
                    lang === "es"
                        ? "bg-tinta text-white"
                        : "hover:text-tinta"
                }`}
            >
                ES
            </button>
            <button
                type="button"
                onClick={() => choose("en")}
                aria-pressed={lang === "en"}
                data-testid="lang-en-btn"
                className={`rounded-full px-3 py-1 transition-colors ${
                    lang === "en"
                        ? "bg-tinta text-white"
                        : "hover:text-tinta"
                }`}
            >
                EN
            </button>
        </div>
    );
};
